module.exports = __webpack_public_path__ + "static/media/Modelo_Destaque Atvos_Produtividade e Inovação.1e580e6b.docx";